import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import "../styles/Home.css";
import "../styles/variables.css";

class Home extends React.Component {
  componentDidMount() {
    const { isAuthenticated, history } = this.props;
    if (isAuthenticated) {
      history.push("/main"); // Redirect to the main page if logged in
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.isAuthenticated && this.props.isAuthenticated) {
      this.props.history.push("/main");
    }
  }

  render() {
    return (
      <div className="home-page">
        <div className="home-title">Hey, you!</div>
        <a href="/login" className="home-button home-button-login">
          Login
        </a>
        <a href="/register" className="home-button">
          Register
        </a>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.user.isAuthenticated,
});

export default withRouter(connect(mapStateToProps)(Home));
